<template>
    <div :class="{'aside-mini-wrap':isCollapse}" class="aside-wrap" ref="aside">
        <el-menu :default-active="onRoutes" :collapse-transition="false" router
                 mode="vertical"
                 :collapse="isCollapse">
            <el-menu-item index="/dashboard" style="font-size: 14px" @click.native="select('首页')">
                <i class="el-icon-menu"></i>
                <span slot="title">首页</span>
            </el-menu-item>
            <template v-for="item in menu">
                <template v-if="item.menu_list">
                    <el-submenu :index="(item.parentResourceId).toString()" :data-in="(item.parentResourceId).toString()">
                        <template slot="title">
                            <i :class="item.parentResourceIcon"></i>
                            <span slot="title" v-show="!isCollapse">{{item.parentResourceName}}</span>
                        </template>
                        <el-menu-item v-for="(subItem,i) in item.menu_list" :key="i" @click.native="select(subItem.resourceName)" :data-in="setMenuUrl(subItem.resourceHtmlUrl)" :index="setMenuUrl(subItem.resourceHtmlUrl)">
                            <i :class="subItem.parentResourceIcon"></i>
                            {{subItem.resourceName}}
                        </el-menu-item>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="setMenuUrl(item.resourceHtmlUrl)" @click.native="select(item.parentResourceName)">
                        <i :class="item.parentResourceIcon"></i>
                        <span slot="title">{{item.parentResourceName}}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import {getSysUserMenu} from '../api/api'

    export default {
        data() {
            return {
                menu:[],
                styleObject:{}
            }
        },
        computed:{
            onRoutes(){
                let routerL = '/'+this.$route.path.split('/')[1];
                return routerL;
            },
            isCollapse:function(){
                if(this.$store.state.navData.navIsCollapse){
                    this.styleObject = {position:'fixed'}
                }
                if(this.$refs.aside){
                    this.$refs.aside.style.height = document.body.clientHeight-60+'px'
                }
                return this.$store.state.navData.navIsCollapse
            },
        },
        mounted(){
            this.getMenu();
            let as = this.$refs.aside;
            as.style.height = document.body.clientHeight-60+'px'
            window.onresize = function(){
                as.style.height = document.body.clientHeight-60+'px'

            }
        },
        methods:{
            getMenu(){
                let _this = this;
                getSysUserMenu({}).then((res) => {
                    console.log(res)
                    _this.menu = res.data.value

                })
            },
            setMenuUrl(url){
                return url.substring(0,1)=="/"?url:'/'+url
            },
            select(item){
                this.$store.commit('ADD_TAB_VIEW',{name:item,path:this.onRoutes})
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../assets/css/public";
    .el-scrollbar{
        height: 100%;
    }
    .aside-wrap{
        width: $asideWidth;
        text-align: center;
        //background: #1E232C!important;
        overflow-y: scroll;
        .aside-index{
            font-size: 14px;
        }
        .el-menu{
            border: none;
        }
        .el-submenu__title{
            font-size: 14px;
        }
        .el-submenu__title i,.el-menu i{
            //color: #ffffff;
            font-size: 14px;
            width: auto;
        }
        .el-submenu__title span{
            margin-right: 30px;
        }
        .el-submenu__title:hover{
            //background: #3b4761!important;
        }
        .el-menu-item{
            font-size: 12px;
            padding-left: 0!important;
            padding-right: 0!important;
        }
        .el-submenu .el-menu-item{
            padding: 0!important;
            min-width: auto;
            //background: #1E232C!important;
        }
        .el-submenu .el-menu-item.is-active{
            //background: #dd4b39!important;
        }
        .el-submenu .el-menu{
            //background: #1E232C!important;
        }

    }
    .aside-mini-wrap{
        width: $asideMiniWidth;
        /*overflow: visible;*/

        .is-active .el-submenu__title{
            //background: #dd4b39!important;
        }
    }
    .el-menu-item:focus, .el-menu-item:hover{
        //background:#3b4761 !important
    }
    .el-menu-item.is-active,.el-menu-item.is-active:focus, .el-menu-item.is-active:hover{
        //background: #dd4b39!important;
    }

</style>


// WEBPACK FOOTER //
// src/components/aside.vue